import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./Change8PackPreferenceForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChange8PackPreference} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validateGreaterThan(errors, values, "frequencyWeeks", 0);
  return errors.toJS();
}

class Change8PackPreferenceFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    console.log("SUBMIT", values.toJS())
    return this.props.changeTransitionPreference(values.set("subscriptionId", this.props.subscriptionId).toJS())
      .then((response) => {
        if (response.data.setPackTransitionPreference.errors.length <= 0) {
          this.handleCancel();
        } else {
          let errors = createValidationErrors(response.data.setPackTransitionPreference.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelChange8PackPreference();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    console.log(data, fromJS(data.packTransitionPreference), "....")

    // A null value means the info for this sub hasn't been inserted into the
    // DB but we know matchBottles should be true by default
    const matchBottles = data.packTransitionPreference.matchBottles === null
      ? true
      : data.packTransitionPreference.matchBottles;

    const initialValues = fromJS({
      matchBottles: matchBottles,
    });

    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        frequency={fromJS(data.subscriptionFrequencyOptions)}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    );
  }
}

// const GET_SUBSCRIPTION = gql`
//   query subscriptionInfo($subscriptionId: ID!) {
//     subscriptionInfo(subscriptionId: $subscriptionId) {
//       frequencyWeeks
//     },
//     subscriptionFrequencyOptions {
//       title
//       value
//     }
//   }
// `;

// const CHANGE_SUBSCRIPTION_FREQUENCY = gql`
//   mutation changeSubscriptionFrequency($data: SubscriptionFrequencyInput!) {
//     changeSubscriptionFrequency(input: $data) {
//       errors { key message }
//     }
//   }
// `;

const PACK_TRANSITION_PREFERENCE = gql`
  query packTransitionPreference($subscriptionId:ID!) {
    packTransitionPreference(subscriptionId: $subscriptionId) {
      matchBottles
    }
  }
`;
const SET_PACK_TRANSITION_PREFERENCE = gql`
  mutation setPackTransitionPreference($data: SetPackTransitionPreferenceInput!) {
    setPackTransitionPreference(input: $data) {
      errors { key message}
    }
  }
`

const withQuery = compose(
  graphql(PACK_TRANSITION_PREFERENCE, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        subscriptionId: props.subscriptionId
      }
    })
  }),
  graphql(SET_PACK_TRANSITION_PREFERENCE, {
    props: ({ mutate }) => ({
      changeTransitionPreference: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelChange8PackPreference})(withQuery(Change8PackPreferenceFormContainer));
